import apiClient from './api';

// TopicTree 服务
export const topicTreeService = {
  // 获取所有topic记录
  getAllTopics: () => apiClient.get('/topic-tree'),
  
  // 根据ID获取单个topic
  getTopicById: (id) => apiClient.get(`/topic-tree/${id}`),
  
  // 创建新的topic
  createTopic: (topicData) => apiClient.post('/topic-tree', topicData),
  
  // 更新topic
  updateTopic: (id, topicData) => apiClient.put(`/topic-tree/${id}`, topicData),
  
  // 删除topic
  deleteTopic: (id) => apiClient.delete(`/topic-tree/${id}`),
  
  // 批量删除topic
  deleteMultipleTopics: (ids) => apiClient.delete('/topic-tree/batch', { data: { ids } }),
  
  // 获取topic树结构
  getTopicTree: () => apiClient.get('/topic-tree/tree'),
  
  // 搜索topic
  searchTopics: (keyword) => apiClient.get(`/topic-tree/search?keyword=${encodeURIComponent(keyword)}`),
  
  // AI推荐主题标签
  recommendTopicTags: (data) => apiClient.post('/topic-tree/recommend-topic-tags', data)
};

export default topicTreeService; 